export default __webpack_public_path__ + "static/media/slope.b36b6a3b.svg";